<script>
  import VisaCard from './VisaCard.svelte'
  import MasterCard from './MasterCard.svelte'
  import AmexCard from './AmexCard.svelte'
  import DiscoverCard from './DiscoverCard.svelte'
  import DinersCard from './DinersCard.svelte'
  import JCBCard from './JCBCard.svelte'
  import UnionPayCard from './UnionPayCard.svelte'
  import DefaultCard from './DefaultCard.svelte'

  export let brand
</script>

{#if brand === 'visa'}
  <VisaCard />
{:else if brand === 'mastercard'}
  <MasterCard />
{:else if brand === 'amex'}
  <AmexCard />
{:else if brand === 'discover'}
  <DiscoverCard />
{:else if brand === 'diners'}
  <DinersCard />
{:else if brand === 'jcb'}
  <JCBCard />
{:else if brand === 'unionpay'}
  <UnionPayCard />
{:else}
  <DefaultCard />
{/if}